import { projectDeliveryRejectedKey } from 'root/src/shared/constants/keys'
import { REJECT_DELIVERY_BRAND } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'
import { REVIEW_DELIVERY_BRAND } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { BRAND_PENDING_DELIVERIES_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[REJECT_DELIVERY_BRAND]: {
		endpointId: REVIEW_DELIVERY_BRAND,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectDeliveryRejectedKey],
		],
		validation: [{ prop: 'message', type: 'required' }],
		label: 'Reject dare',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectDeliveryRejectedKey,
			},
		],
		onSuccessRedirect: { routeId: BRAND_PENDING_DELIVERIES_ROUTE_ID },
	},
}
